import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookiesBannerComponent } from "./Pages/cookies-banner/cookies-banner.component";
import { LoadingScreenComponent } from "./common-component/loading-screen/loading-screen.component";
import { SharedService } from './core/services/shared/shared.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookiesBannerComponent, LoadingScreenComponent,CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('anybid');
    private sharedService = inject(SharedService);
  userData: any = null;
  showSpinner: boolean = false;
  showSpinner$ = this.sharedService.showSpinner;

  constructor() {
    const userData = localStorage.getItem('user');
    this.userData = userData ? JSON.parse(userData) : null;
  }
  ngOnInit() {
    // y
 
  }
}
